// @flow strict

import * as React from 'react'
import styles from './MarkdownContent.module.scss'
import marked from 'marked'
import toReact from 'react-html-parser'
import { type PropsWithChildren } from '@mondough/public-web-components'

export type ContentTheme = 'dark' | 'grey' | 'light'
export type Props = PropsWithChildren<
  {
    className?: string,
    theme?: ContentTheme,
    ariaHidden?: boolean,
  },
  // We set the child property to string
  // as we want to be dealing with markdown.
  string,
>

const RENDERER = new marked.Renderer()
// We want to wrap tables in a div
// that we can then scroll when the screen becomes smaller
RENDERER.table = (header, body) => `<div data-table-scrollable>
  <table>
    <thead>${header}</thead>
    ${body ? `<tbody>${body}</tbody>` : ''}
  </table>
</div>`

export const ContentThemes: { [k: string]: ContentTheme } = {
  DARK: 'dark',
  LIGHT: 'light',
  GREY: 'grey',
}

export const MarkdownContent = ({
  children = '',
  className,
  theme = ContentThemes.LIGHT,
  ariaHidden = false,
}: Props) => (
  <div className={styles[theme]} aria-hidden={ariaHidden ? 'true' : undefined}>
    {className != null ? (
      <div className={className}>
        {toReact(
          marked(children, { gfm: true, breaks: true, renderer: RENDERER }),
        )}
      </div>
    ) : (
      <>
        {toReact(
          marked(children, { gfm: true, breaks: true, renderer: RENDERER }),
        )}
      </>
    )}
  </div>
)
